const PLAN_URLS = { 
  GET_PLANS: "/plan_sub/get_plans",
  GET_CURRENT_PLAN: "/plan_sub/get_current_subscription",
  ADD_SUBCRIPTION: "/plan_sub/add_subscription",
  ADD_SUBCRIPTION_BY_ADMIN: "/plan_sub/add_subscription_by_admin",
  CANCEL_SUBCRIPTION: "/plan_sub/cancel_subscription",
  CANCEL_STARTED_SUBCRIPTION: "/plan_sub/cancel_started_subscription",
  GET_USER_PLAN: "/plan_sub/get_user_subscription",
  UPDATE_PLAN: "/plan_sub/update_payment",
  GET_ALL_PLANS_BY_CATEGORY:"/plan_sub/get_all_plans_by_category"
};

const SUBSCRIPTION_URLS={
  GET_ALL:"/plan_sub/get_all_subscriptions"
}
  
  
export { PLAN_URLS,SUBSCRIPTION_URLS };
